/** 供方权限 */
export enum SupplyPermission {
  /** <-----------质检报告------------> */
  /** 质检报告查看 */
  QualityInspectionReportView = 'supplier:quality-inspection-report:view-reports',
  /** 质检报告上传 */
  QualityInspectionReportPublish = 'supplier:quality-inspection-report:upload-reports',
  /** 质检报告编辑 */
  QualityInspectionReportEdit = 'supplier:quality-inspection-report:edit-reports',
  /** 质检报告删除 */
  QualityInspectionReportDelete = 'supplier:quality-inspection-report:delete-reports',
  /** <-----------非监管商品------------> */
  /** 查看非监管商品 */
  SupplyUnsuperviseCommodityView = 'supplier:non-monitored-commodity-list:view-commodities',
  /** 新建非监管商品 */
  SupplyUnsuperviseCommodityNew = 'supplier:non-monitored-commodity-list:create-commodities',
  /** 编辑非监管商品 */
  SupplyUnsuperviseCommodityEdit = 'supplier:non-monitored-commodity-list:edit-commodities',
  /** 启用非监管商品 */
  SupplyUnsuperviseCommodityEnable = 'supplier:non-monitored-commodity-list:enable-commodities',
  /** 禁用非监管商品 */
  SupplyUnsuperviseCommodityDisEnable = 'supplier:non-monitored-commodity-list:disable-commodities',
  /** 禁用非监管商品 */
  SupplyUnsuperviseCommodityDelect = 'supplier:non-monitored-commodity-list:delete-commodities',
  /** 批量导入非监管商品 */
  SupplyUnsuperviseCommodityBatchImport = 'supplier:non-monitored-commodity-list:batch-import',
  /** 批量导入非监管商品 */
  SupplyUnsuperviseCommodityBatchExport = 'supplier:non-monitored-commodity-list:batch-export',
  /** 批量启用非监管商品 */
  SupplyUnsuperviseCommodityBatchEnable = 'supplier:non-monitored-commodity-list:batch-enable',
  /** 批量禁用非监管商品 */
  SupplyUnsuperviseCommodityBatchDisEnable = 'supplier:non-monitored-commodity-list:batch-disable',
  /** 批量删除非监管商品 */
  SupplyUnsuperviseCommodityBatchDelect = 'supplier:non-monitored-commodity-list:batch-delete',
  /** 批量编辑非监管商品 */
  SupplyUnsuperviseCommodityBatchEdit = 'supplier:non-monitored-commodity-list:batch-update-info',
  /** <-----------采购合同------------> */
  /** 查看采购合同 */
  PurchaseContractView = 'supplier:purchase-contract-list:view-purchase-contracts',
  /** 采购合同创建 */
  SupplyPurchaseContractCreate = 'supplier:purchase-contract-list:create-purchase-contracts',
  /** 采购合同编辑 */
  SupplyPurchaseContractEdit = 'supplier:purchase-contract-list:edit-purchase-contracts',
  /** 采购合同删除 */
  SupplyPurchaseContractDelect = 'supplier:purchase-contract-list:delete-purchase-contracts',
  /** 采购合同发布 */
  SupplyPurchaseContractPublish = 'supplier:purchase-contract-list:publish-purchase-contracts',
  /** 采购合同关闭 */
  SupplyPurchaseContractClose = 'supplier:purchase-contract-list:close-purchase-contracts',
  /** 采购合同导入报价商品 */
  SupplyPurchaseContractImportQuotedProducts = 'supplier:purchase-contract-list:import-quoted-commodities',
  /** 采购合同导出 */
  SupplyPurchaseContractExport = 'supplier:purchase-contract-list:export-purchase-contracts',
  /** 采购合同复制 */
  SupplyPurchaseContractCopy = 'supplier:purchase-contract-list:copy-purchase-contracts',
  /** 采购合同批量发布 */
  SupplyPurchaseContractBatchPublish = 'supplier:purchase-contract-list:batch-publish',
  /** 采购合同批量导出 */
  SupplyPurchaseContractBatchExport = 'supplier:purchase-contract-list:batch-export',
  /** 采购合同批量删除 */
  SupplyPurchaseContractBatchDelect = 'supplier:purchase-contract-list:batch-delete',
  /** 采购合同批量关闭 */
  SupplyPurchaseContractBatchClose = 'supplier:purchase-contract-list:batch-close',
  /** 采购合同批量改价 */
  SupplyPurchaseContractBatchChangePrice = 'supplier:purchase-contract-list:batch-change-price',
  /** <-----------询价单------------> */
  /** 询价单查看 */
  InquiryView = 'supplier:inquiry-list:view-inquiry-order-detail',
  /** 询价单报价 */
  InquirySheetOffer = 'supplier:inquiry-list:quote',
  /** 询价单报价查看 */
  InquirySheetOfferView = 'supplier:inquiry-list:view-quotes',
  /** 询价单合同查看 */
  InquirySheetContractView = 'supplier:inquiry-list:view-contracts',
  /** <-----------报价单------------> */
  /** 报价单查看 */
  OfferOrderView = 'supplier:quotation-management:view-quotation-orders',
  /** 报价单新建 */
  OfferOrderNew = 'supplier:quotation-management:create-quotation-orders',
  /** 报价单编辑 */
  OfferOrderEdit = 'supplier:quotation-management:edit-quotation-orders',
  /** 报价单复制 */
  OfferOrderCopy = 'supplier:quotation-management:copy-quotation-orders',
  /** 报价单删除 */
  OfferOrderDelete = 'supplier:quotation-management:delete-quotation-orders',
  /**  ================================ '价格监控 ================================ '*/
  /** 批量导出 */
  MonitorBatchExport = 'supplier:price-monitoring:batch-export',
  /** <-----------采购单------------> */
  /** 采购单查看 */
  PurchaseOrderView = 'supplier:purchase-order-management:view-purchase-orders',
  /** 采购单编辑 */
  PurchaseOrderEdit = 'supplier:purchase-order-management:edit-purchase-orders',
  /** 采购单质检报告查看 */
  PurchaseOrderQualityInspectionReportView = 'supplier:purchase-order-management:view-quality-inspection-reports',
  /** 采购单收货记录查看 */
  PurchaseOrderReceiptRecordView = 'supplier:purchase-order-management:view-receipt-records',
  /** 采购单备货 */
  PurchaseOrderStockUp = 'supplier:purchase-order-management:prepare-purchase-orders',
  /** 采购单发货 */
  PurchaseOrderDeliverGoods = 'supplier:purchase-order-management:ship-purchase-orders',
  /** 采购单撤回 */
  PurchaseOrderWithdraw = 'supplier:purchase-order-management:recall-purchase-orders',
  /** 采购单打印 */
  PurchaseOrderPrint = 'supplier:purchase-order-management:print-purchase-orders',
  /** 采购单批量打印 */
  PurchaseOrderBatchPrint = 'supplier:purchase-order-management:batch-print',
  /** 采购单批量备货 */
  PurchaseOrderBatchStockUp = 'supplier:purchase-order-management:batch-prepare',
  /** 采购单批量发货 */
  PurchaseOrderBatchDeliverGoods = 'supplier:purchase-order-management:batch-ship',
  /** 采购单批量导出 */
  PurchaseOrderBatchExport = 'supplier:purchase-order-management:batch-export',
  /** 采购单批量改价 */
  PurchaseOrderBatchModifyPrice = 'supplier:purchase-order-management:bulk-repricing',
  /** 维护分拣记录 */
  PurchaseOrderUpdateSortingRecord = 'supplier:purchase-order-management:maintain-sorting-records',
  /** <-----------采购需求汇总------------> */
  /** 采购需求汇总列表 */
  ProcurementDemandSummaryList = 'supplier:purchase-demand-summary:view-summary-list',
  /** 采购需求汇总批量导出 */
  ProcurementDemandSummaryBatchExport = 'supplier:purchase-demand-summary:batch-export',
  /** 采购明细 */
  ProcurementDemandSummaryDetail = 'supplier:purchase-demand-summary:detail',
  /** 采购需求汇总打印 */
  ProcurementDemandSummaryPrint = 'supplier:purchase-demand-summary:print',
  /** 采购需求汇总批量打印 */
  ProcurementDemandSummaryBatchPrint = 'supplier:purchase-demand-summary:batch-print',
  /** <-----------支付流水------------> */
  /** 付款单查看 */
  PaymentOrderView = 'supplier:payment-flow:view-payment-orders',
  /** 付款单核销 */
  PaymentOrderWriteOff = 'supplier:payment-flow:write-off-payment-orders',
  /** 付款单批量核销 */
  PaymentOrderBatchWriteOff = 'supplier:payment-flow:batch-write-off',
  /** 付款单批量导出 */
  PaymentOrderBatchExport = 'supplier:payment-flow:batch-export',
  /** 付款单审核 */
  PaymentOrderAudit = 'supplier:payment-flow:audit',
  /** <-----------对账单------------> */
  /** 对账单查看 */
  ReconciliationOrderView = 'supplier:reconciliation-management:view-reconciliation-statements',
  /** 对账单确认 */
  ReconciliationOrderConfirm = 'supplier:reconciliation-management:confirm-reconciliation-statements',
  /** 对账单批量确认 */
  ReconciliationOrderBatchConfirm = 'supplier:reconciliation-management:batch-confirm',
  /** 对账单批量导出 */
  ReconciliationOrderBatchExport = 'supplier:reconciliation-management:batch-export',
  /** <-----------应收汇总------------> */
  /** 应收汇总批量导出 */
  AccountsReceivableSummaryBatchExport = 'supplier:receivable-summary:batch-export',
  /** -----------------开票记录------------------- */
  /** 新建开票记录 */
  BillRecordNew = 'supplier:invoice-record:add',
  /** 编辑开票记录 */
  BillRecordEdit = 'supplier:invoice-record:editing',
  /** 提交开票记录 */
  BillRecordSubmit = 'supplier:invoice-record:submit',
  /** 作废开票记录 */
  BillRecordCancel = 'supplier:invoice-record:nullify',
  /** 删除开票记录 */
  BillRecordDelete = 'supplier:invoice-record:delete',
  /** 批量作废 */
  BillRecordBatchCancel = 'supplier:invoice-record:batch-nullify',
  /** 批量删除 */
  BillRecordBatchDelete = 'supplier:invoice-record:batch-delete',
  /** 批量导出 */
  BillRecordBatchExport = 'supplier:invoice-record:excel',
  /** 查看开票记录 */
  BillRecordView = 'supplier:invoice-record:get-info',
  /** <-----------采购汇总------------> */
  /** 采购汇总批量导出 */
  ProcurementSummaryBatchExport = 'supplier:purchase-summary-table:batch-export',
  /** <-----------用户管理------------> */
  /** 用户新建 */
  UserNew = 'supplier:user-management:create-users',
  /** 用户编辑 */
  UserEdit = 'supplier:user-management:edit-users',
  /** 用户修改密码 */
  UserEditPassword = 'supplier:user-management:change-passwords',
  /** 用户启用 */
  UserEnable = 'supplier:user-management:enable-users',
  /** 用户禁用 */
  UserDisable = 'supplier:user-management:disable-users',
  /** 用户删除 */
  UserDelete = 'supplier:user-management:delete-users',
  /** 用户批量启用 */
  UserBatchEnable = 'supplier:user-management:batch-enable',
  /** 用户批量禁用 */
  UserBatchDisable = 'supplier:user-management:batch-disable',
  /** 用户批量删除 */
  UserBatchDelete = 'supplier:user-management:batch-delete',
  /** <-----------角色管理------------> */
  /** 角色新建 */
  RoleNew = 'supplier:role-management:create-roles',
  /** 角色编辑 */
  RoleEdit = 'supplier:role-management:edit-roles',
  /** 角色删除 */
  RoleDelete = 'supplier:role-management:delete-roles',

  /**  ================================ '员工管理 ================================ '*/
  /** 查看员工 */
  EmployeeView = 'supplier:employee-management:view-employees',
  /** 新建员工 */
  EmployeeNew = 'supplier:employee-management:create-employees',
  /** 编辑员工 */
  EmployeeEdit = 'supplier:employee-management:edit-employees',
  /** 启用员工 */
  EmployeeEnable = 'supplier:employee-management:enable-employees',
  /** 禁用员工 */
  EmployeeDisable = 'supplier:employee-management:disable-employees',
  /** 删除员工 */
  EmployeeDelete = 'supplier:employee-management:delete-employees',
  /** 批量启用 */
  EmployeeBatchEnable = 'supplier:employee-management:batch-enable',
  /** 批量禁用 */
  EmployeeBatchDisable = 'supplier:employee-management:batch-disable',
  /** 批量删除 */
  EmployeeBatchDelete = 'supplier:employee-management:batch-delete',
  /** 批量导入 */
  EmployeeBatchImport = 'supplier:employee-management:import',
  /** 批量导出 */
  EmployeeBatchExport = 'supplier:employee-management:export',
  /**  ================================ 配送任务 ================================ '*/
  /** 查看配送任务 */
  DeliveryTaskView = 'supplier:delivery-management:task-detail',
  /** 一键排线 */
  QuickWiring = 'supplier:delivery-management:task-add-plan',
  /** 新增配送任务 */
  DeliveryTaskAdd = 'supplier:delivery-management:task-add',
  /** 编辑配送任务 */
  DeliveryTaskEdit = 'supplier:delivery-management:task-update',
  /** 完成配送任务 */
  DeliveryTaskFinish = 'supplier:delivery-management:task-finish',
  /** 关闭配送任务 */
  DeliveryTaskClose = 'supplier:delivery-management:task-close',
  /** 删除配送任务 */
  DeliveryTaskDelete = 'supplier:delivery-management:task-delete',
  /** 批量删除 */
  DeliveryTaskBatchDelete = 'supplier:delivery-management:task-batch-delete',
  /** 批量关闭 */
  DeliveryTaskBatchClose = 'supplier:delivery-management:task-batch-close',
  /** 批量完成 */
  DeliveryTaskBatchFinish = 'supplier:delivery-management:task-batch-finish',
  /** 批量打印 */
  DeliveryTaskBatchPrint = 'supplier:delivery-management:task-print',
  /**  ================================ 配送路线 ================================ '*/
  /** 查看配送路线 */
  DeliveryLineView = 'supplier:delivery-management:line-detail',
  /** 新增配送路线 */
  DeliveryLineAdd = 'supplier:delivery-management:line-add',
  /** 编辑配送路线 */
  DeliveryLineEdit = 'supplier:delivery-management:line-update',
  /** 删除配送路线 */
  DeliveryLineDelete = 'supplier:delivery-management:line-delete',
  /** 批量删除配送路线 */
  DeliveryLineBatchDelete = 'supplier:delivery-management:line-batch-delete',
  /**  ================================ 司机管理 ================================ '*/
  /** 新增司机 */
  DriverAdd = 'supplier:delivery-management:diver-add',
  /** 编辑司机 */
  DriverEdit = 'supplier:delivery-management:diver-update',
  /** 删除司机 */
  DriverDelete = 'supplier:delivery-management:diver-delete',
  /** 批量删除司机 */
  DriverBatchDelete = 'supplier:delivery-management:diver-batch-delete',
  /**  ================================ 车辆 ================================ '*/
  /** 查看车辆列表 */
  CarView = 'supplier:car-list',
  /** 新建车辆 */
  CarCreate = 'supplier:car-add',
  /** 编辑车辆 */
  CarEdit = 'supplier:car-update',
  /** 删除车辆 */
  CarDelete = 'supplier:car-delete',
  /** 批量删除 */
  CarBatchDelete = 'supplier:car-batch-delete',
  /**  ================================ 收支项目管理 ================================ */
  /** 查看收支项目 */
  IncomeExpenseProjectView = 'supplier:revenue-record:detail',
  /** 新建收支项目 */
  IncomeExpenseProjectNew = 'supplier:revenue-record:save',
  /** 编辑收支项目 */
  IncomeExpenseProjectEdit = 'supplier:revenue-record:detail:update',
  /** 删除收支项目 */
  IncomeExpenseProjectDelete = 'supplier:revenue-record:delete',
  /** 收支项目管理 */
  IncomeExpenseProjectManage = 'supplier:revenue-record:manage:list',
  /** 批量删除收支项目 */
  IncomeExpenseProjectBatchDelete = 'supplier:revenue-record:batchDelete',
  /** 批量导出收支项目 */
  IncomeExpenseProjectBatchExport = 'supplier:revenue-record:exportExcel:record',
  /**  ================================ 财务汇总表 ================================ */
  /** 批量导出 */
  FinancialSummaryBatchExport = 'supplier:revenue:statistics-export',
  /**  ================================ 周转筐记录 ================================ */
  /** 查看周转筐记录 */
  TurnoverBasketRecordView = 'supply:turnover-basket:detail',
  /** 新增周转筐记录 */
  TurnoverBasketRecordAdd = 'supply:turnover-basket:add',
  /** 编辑周转筐记录 */
  TurnoverBasketRecordEdit = 'supply:turnover-basket:update',
  /** 提交周转筐记录 */
  TurnoverBasketRecordSubmit = 'supply:turnover-basket:finish',
  /** 关闭周转筐记录 */
  TurnoverBasketRecordClose = 'supply:turnover-basket:close',
  /** 删除周转筐记录 */
  TurnoverBasketRecordDelete = 'supply:turnover-basket:delete',
  /** 周转筐管理 */
  TurnoverBasketManage = 'supply:turnover-basket:manage',
  /** 批量删除周转筐记录 */
  TurnoverBasketRecordBatchDelete = 'supply:turnover-basket:batch-delete',
  /** 批量关闭周转筐记录 */
  TurnoverBasketRecordBatchClose = 'supply:turnover-basket:batch-close',
  /**  ================================ 周转筐统计 ================================ */
  /** 周转筐统计批量导出 */
  TurnoverBasketStatisticsBatchExport = 'supply:turnover-basket:statistic',
  /**  ================================ 套餐管理 ================================ */
  /** 套餐列表 */
  PackageManageList = 'supervisor:supplier-performance:menu-fixed:list',
  /** 查看套餐 */
  PackageManageView = 'supervisor:supplier-performance:menu-fixed:view',
  /** 新建套餐 */
  PackageManageNew = 'supervisor:supplier-performance:menu-fixed:add',
  /** 编辑套餐 */
  PackageManageEdit = 'supervisor:supplier-performance:menu-fixed:edit',
  /** 删除套餐 */
  PackageManageDelete = 'supervisor:supplier-performance:menu-fixed:deleted',
  /** 批量导出套餐 */
  PackageManageBatchExport = 'supervisor:supplier-performance:menu-fixed:export',
  /** 批量删除套餐 */
  PackageManageBatchDelete = 'supervisor:supplier-performance:menu-fixed:batch-deleted',
  /**  ================================ 报餐记录 ================================ */
  /** 报餐列表 */
  MealRecordList = 'supervisor:supplier-performance:menu-record:list',
  /** 查看报餐记录 */
  MealRecordView = 'supervisor:supplier-performance:menu-record:view',
  /** 批量导出 */
  MealRecordBatchExport = 'supervisor:supplier-performance:menu-record:export',
  /**  ================================ 套餐需求汇总 ================================ */
  /** 套餐需求汇总列表 */
  PackageDemandSummaryList = 'supervisor:supplier-performance:menu-record-summary:list',
  /** 套餐需求汇总导出 */
  PackageDemandSummaryExport = 'supervisor:supplier-performance:menu-record-summary:export',
  /**  ================================ 商品税率 ================================ */
  /** 商品税率列表 */
  TaxRateList = 'supervisor:tax_rate:list',
  /** 商品税率设置 */
  TaxRateSet = 'supervisor:tax_rate:set-tax',
  /** 商品税率批量设置 */
  TaxRateBatchSet = 'supervisor:tax_rate:batch-set-tax',
  /** 商品税率批量导出 */
  TaxRateBatchExport = 'supervisor:tax_rate:export',
  /** 商品税率批量导入 */
  TaxRateBatchImport = 'supervisor:tax_rate:import',
  /**  ================================ 滞销品 ================================ */
  /** 滞销品列表 */
  DeadStockList = 'supplier:unsoldProduct:query-list',
  /** 滞销品规则设置 */
  DeadStockRuleSet = 'supplier:unsoldProduct:update-category-unsold-days',
  /** 批量导出 */
  DeadStockBatchExport = 'supplier:unsoldProduct:export-unsold-product',
  /**  ================================ 项目 ================================ */
  /** 项目列表 */
  ProjectList = 'supplier:project:list',
  /** 投标 */
  ProjectBid = 'supplier:project:create-pact',
  /** 查看报价 */
  ProjectViewQuotation = 'supplier:project:quotation-view',
  /** 查看合同 */
  ProjectViewPact = 'supplier:project:pact-view',
  /**  ================================ 售后单 ================================ */
  /** 售后单查看列表 */
  AfterSalesList = 'supervisor:after-sale:list',
  /** 售后单查看明细 */
  AfterSalesDetail = 'supervisor:after-sale:page',
  /** 售后单确认 */
  AfterSalesConfirm = 'supervisor:after-sale:confirm',
  /** 售后单撤回 */
  AfterSalesRevoke = 'supervisor:after-sale:revoke',
  /** 售后单退货验收 */
  AfterSalesAcceptance = 'supervisor:after-sale:acceptance',
  /** 查看退货记录 */
  AfterSalesReturn = 'supervisor:after-sale:retrun-record',
  /** 查看验收记录 */
  AfterSalesCheck = 'supervisor:after-sale:update-acceptance-record',
  /** 售后单批量导出 */
  AfterSalesBatchExport = 'supervisor:after-sale:batch-export',
  /** 售后单批量确认 */
  AfterSalesBatchConfirm = 'supervisor:after-sale:batch-chonfirm',
  /** 售后单批量退货验收 */
  AfterSalesBatchAcceptance = 'supervisor:after-sale:batch-acceptance',

  /**  ================================ 商品行情价 ================================ */
  /** 商品行情价查看列表 */
  MarketPriceList = 'supplier:market-price:list',
  /** 商品行情价查看明细 */
  MarketPriceDetail = 'supplier:market-price:get-info',
  /**  ================================ 折扣定价 ================================ */
  /** 折扣定价查看列表 */
  DiscountPriceList = 'supplier:discounted-pricing:list',
  /** 折扣定价查看明细 */
  DiscountPriceDetail = 'supplier:discounted-pricing:get-info',
  /** 折扣定价报价 */
  DiscountPriceQuotation = 'supplier:discounted-pricing:quotation',
  /** 折扣定价查看报价 */
  DiscountPriceQuotationDetail = 'supplier:discounted-pricing:get-quotation-info',
  /**  ================================ 采购商品备注 ================================ */
  /** 采购商品备注列表 */
  PurchaseSkuRemarkList = 'supervisor:product-remark:list',
  /** 采购商品备注导出 */
  PurchaseSkuRemarkExport = 'supervisor:product-remark:batch-export',
  /**  ================================ 司机绩效 ================================ */
  /** 司机绩效列表 */
  DriverPerformanceList = 'supervisor:delivery-performance:list',
  /** 司机绩效导出 */
  DriverPerformanceExport = 'supervisor:delivery-performance:batch-export',
  /**  ================================ 采购明细表 ================================ */
  /** 采购明细表 */
  PurchaseDetailList = 'supplier:purchase-summary:list',
  /** 批量导出 */
  PurchaseDetailBatchExport = 'supplier:purchase-summary:export',
  /**  ================================ 现场监控违规记录 ================================ */
  /** 违规记录列表 */
  ViolationRecordList = 'supervisor:violation-record:supplier-list',
  /** 违规记录删除 */
  ViolationRecordDelete = 'supervisor:violation-record:supplier-delete',
  /** 违规记录批量删除 */
  ViolationRecordBatchDelete = 'supervisor:violation-record:supplier-batch-delete',
}
